import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';

@Component({
  selector: 'tools-tabbed-nav-list',
  templateUrl: './tabbed-nav-list.component.html',
  styleUrls: ['./tabbed-nav-list.component.scss'],
})
export class TabbedNavListComponent implements OnInit, OnChanges {
  @Input() list: Object[];
  @Input() activeTab = 0;
  @Input() disabled: boolean;

  @Output() selected: EventEmitter<Object> = new EventEmitter<Object>();

  activeSection: string;
  @Input() activePage: Object;

  ngOnInit() {
    if (this.list && this.list.length >= this.activeTab + 1) {
      this.activePage = this.list[this.activeTab.valueOf()]['Links'][0];
    }

    if (this.list?.length) {
      this.focusButton(this.list[0]['Text']);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled']) {
      this.disabled = changes['disabled'].currentValue;
    }

    if (changes['activePage'] && changes['activePage'].currentValue != null) {
      this.clearActive();
      this.pageClicked(changes['activePage'].currentValue);
    }
  }

  clearActive() {
    for (let i = 0; i < this.list[0]['Links'].length; i++) {
      this.list[0]['Links'][i]['Active'] = false;
    }
  }

  focusButton(name: string) {
    setTimeout(() => {
      const elem = document.getElementById(name);
      if (elem != null) {
        elem.classList.add('focus');
      }
    }, 100);
  }

  removeFocusFromButtons = () => {
    const nav = document.getElementsByClassName('nav-headings')[0];
    if (nav != null) {
      for (let i = 0; i < nav.childElementCount; i++) {
        nav.children[i].classList.remove('focus');
      }
    }
  };

  navLinkClicked = (page: string) => {
    if (this.disabled) {
      return;
    }
    this.activeSection = page;
    for (let i = 0; i < this.list.length; i++) {
      if (this.list[i]['Text'] == page) {
        this.activeTab = i;
      }
    }
    this.removeFocusFromButtons();
    this.focusButton(page);
  };

  pageClicked = (page: Object) => {
    if (this.disabled) {
      return;
    }

    if (this.activePage == null) {
      this.clearActive();
    } else {
      this.activePage['Active'] = false;
    }
    this.activePage = page;
    this.activePage['Active'] = true;
    this.emitSelection();
  };

  emitSelection() {
    this.selected.emit(this.activePage);
  }
}
